import { CircularProgress } from '@material-ui/core';
import React, { useState, useEffect, useContext } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import { StoreContext } from '../../../../../store/Provider'
import './shipmentDetailsComp.css'

function ShipmentDetailsComp(props) {

    const [detail, setDetail] = useState({})
    const [loading, setLoading] = useState(false)
    const context = useContext(StoreContext)

    useEffect(() => {
        setDetail(props.detail.data)
        setLoading(props.detail.loading)
    }, [props])


    if (loading) {
        return (
            <div className="loadingClass">
                <CircularProgress size="1.5rem" />
            </div>
        )
    }

    const showContainer = () => {
        // context.setContainerShow(true);
        context.setTabValue(3);
    }

    return (
        <div className="shipmentDetailsComp">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <label>House Bill</label>
                            <p title={detail.HouseBillNumber}>{detail.HouseBillNumber}</p>
                        </td>
                        <td>
                            <label>Order Ref #</label>
                            <p title={detail.OrderRef}>{detail.OrderRef}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Shipper</label>
                            <p title={detail.ConsignorName}>{detail.ConsignorName}</p>
                        </td>
                        <td>
                            <label>Weight</label>
                            <p>{detail.TotalWeight} {detail.TotalWeightUQ}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Main Vessel</label>
                            <p title={detail.VesselName}>{detail.VesselName}</p>
                        </td>
                        <td>
                            <label>Master BL</label>
                            <p title={detail.MasterBillNumber}>{detail.MasterBillNumber}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>Volume</label>
                            <p>{detail.TotalVolume}m<sup>3</sup></p>
                        </td>
                        <td>
                            <label>Container Quantity</label>
                            <p>{detail.ContainerCount}</p>
                        </td>
                    </tr>
                    <tr>
                        <td className='containerNumber'>
                            <span><label>Container Numbers</label><LaunchIcon className='pointer' onClick={showContainer} /></span>
                            <p title={detail.ContainerNumbers}>{detail.ContainerNumbers ? detail.ContainerNumbers.replaceAll(',', ', ') : null}</p>
                        </td>
                        <td>
                            <label>Container Type</label>
                            <p>{detail.ContainerMode}</p>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    )
}

export default ShipmentDetailsComp
